import { render, staticRenderFns } from "./c_hot_word.vue?vue&type=template&id=07d8fa9e&scoped=true"
import script from "./c_hot_word.vue?vue&type=script&lang=js"
export * from "./c_hot_word.vue?vue&type=script&lang=js"
import style0 from "./c_hot_word.vue?vue&type=style&index=0&id=07d8fa9e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d8fa9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/crmeb/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07d8fa9e')) {
      api.createRecord('07d8fa9e', component.options)
    } else {
      api.reload('07d8fa9e', component.options)
    }
    module.hot.accept("./c_hot_word.vue?vue&type=template&id=07d8fa9e&scoped=true", function () {
      api.rerender('07d8fa9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobileConfigRight/c_hot_word.vue"
export default component.exports